import { withHandlers } from "recompose";

export const addPaymentTaxLineHandler = withHandlers({
  // add tax line to a banktransaction line
  addPaymentTaxLine: ({
    prepareTaxLine,
    updateLine,
    companyDefaultInfos
    // computeTotals
  }) => async (customValues = {}) => {
    let taxPieces = Array.from(customValues.line.taxPieces || []);
    const newTaxLine = prepareTaxLine(
      taxPieces.length,
      parseFloat(customValues.line.amount),
      companyDefaultInfos
    );
    taxPieces.push(newTaxLine);

    const newLine = { ...customValues.line, taxPieces };
    await updateLine(customValues.lineIndex, newLine);

    // computeTotals();
  }
});
